import db from '@/app/(db)/main'

export const getHistoryFromDb = db.getHistoryFromDb
export const getChatFromDB = db.getChatFromDB
export const removeHistory = db.removeHistory
export const removeChat = db.removeHistory  // Alias for backward compatibility
export const clearHistory = db.clearHistory
export const getSharedChat = db.getSharedChat
export const shareChat = db.shareChat ?? undefined
export const disableSharedChat = db.disableSharedChat
export const saveChat = db.saveChat
export const refreshHistory = db.refreshHistory
export const getMissingKeys = db.getMissingKeys
export const getHistoryMetaFromDb = db.getHistoryMetaFromDb
export const saveHistoryResult = db.saveHistoryResult
// Auth user/referral helpers
export const getUserByEmail = db.getUserByEmail
export const setUserByEmail = db.setUserByEmail
export const getReferralByCode = db.getReferralByCode

// GitHub connection functions
export const getGithubConnection = db.getGithubConnection
export const saveGithubConnection = db.saveGithubConnection
export const deleteGithubConnection = db.deleteGithubConnection
export const validateGithubToken = db.validateGithubToken

// GitHub App installation functions
export const getGithubInstallation = db.getGithubInstallation
export const saveGithubInstallation = db.saveGithubInstallation
export const deleteGithubInstallation = db.deleteGithubInstallation

// Media Pro functions
export const saveArticle = db.saveArticle
export const getUserArticles = db.getUserArticles
export const getArticleById = db.getArticleById
export const updateArticle = db.updateArticle
export const deleteArticle = db.deleteArticle

// RBAC functions
export const createTeam = db.createTeam
export const createProject = db.createProject
export const getUserTeams = db.getUserTeams
export const getTeamProjects = db.getTeamProjects
export const generateReferral = db.generateReferral
export const redeemReferral = db.redeemReferral
export const createDefaultTeamAndProject = db.createDefaultTeamAndProject
